export const homePageTexts = {
  homePageMainText: "ברוכים הבאים למועדון הלקוחות",
  homePageSlogan: "חברי מועדון פנאקסיה עד הבית נהנים יותר",
  homePagePersonalServiceText: "שירות אישי",
  homePagePharmacistAdviceText: "ייעוץ רוקחי",
  homePageProductInnovationText: "קדימות במוצרים חדשים",
  homePageOffersText: "הטבות ומבצעים בלעדיים",
  joinTheClubLinkText: "הצטרפות למועדון",
  registeredCustomersLinkText: "לקוח רשום? לחץ כאן",
};

export const loginPageTexts = {
  loginPageGreetingText: "כיף לדעת שאתה איתנו",
  loginPageConfirmDetailsText: "נבקש רק לאמת את הפרטים כדי לוודא שהכל תקין",
};

export const registerPageTexts = {
  registerPageMainText: "הפרטים שלי",
};

export const verificationPageTexts = {
  verificationPageMainText: "הפרטים שלי",
  verificationPageExplainationText:
    "נבקש מכם רק אימות קצר על מנת לוודא שהפרטים נכונים אנא הכנס את הקוד שקיבלת לטלפון שמסתיים בספרות ",
  verificationPageResendCodeText: "קוד לא נשלח? לחץ כאן",
  verificationPageGoBackLinkText: "חזרה",
};

export const uploadDocumentsPageTexts = {
  uploadDocumentsPageMainText: "צירוף מסמכים",
  uploadDocumentsPageExplanationText:
    "נבקש ממך לצרף מסמכים המעידים על אישור שימוש בקאנביס רפואי. צילום רישיון שימוש, ומרשמים פתוחים.",
  uploadDocumentsPageAddLicenceText: "הוספת צילום רישיון",
  uploadDocumentsPageAddPrescriptionsText: "הוספת מרשמים פתוחים",
  uploadDocumentsPageContinueLinkText: "המשך",
  uploadDocumentsPageGoBackLinkText: "חזרה",
};

export const userDetailsPageTexts = {
  userDetailsPageMainText: "פרטים אישיים",
};

export const additionalDetailsPageTexts = {
  additionalDetailsPageMainText: "פרטים נוספים",
};

export const finishProcessPageTexts = {
  finishProcessPageMainText: "משלוח וסיום הרשמה",
};

export const successNotificationPageTexts = {
  successNotificationPageSuccessText: "הרשמה בוצעה בהצלחה!",
  successNotificationPageSuccessDetailsText:
    "שמחים על הצטרפותכם למועדון הלקוחות של פנאקסיה! עכשיו תוכלו להינות משירות עד הבית והטבות נוספות",
  successNotificationPageEndProcessText: "סיום",
  successNotificationPageGoToHomepageLinkText: "מעבר לדף הבית",
};

export const existingClubMemberPageTexts = {
  messageHeader: "הינך מופיע כחבר מועדון",
  messageDetails: "אנחנו שמחים להודיע לך כי נמצאת רשום כחבר מועדון! לעדכון פרטים ניתן ליצור קשר עם שרות לקוחות במספר 5329*. ",
  exitLink: "סגור",

}

export const errorNotificationPageTexts = {
  errorNotificationPageMainText: "אופס… נראה שמשהו השתבש",
  errorNotificationPageErrorDetailsText:
    "נראה שתהליך ההרשמה השתבש בדרך, בואו לא נוותר וננסה שוב",
  errorNotificationPageRetryLinkText: "נסה שנית",
  errorNotificationPageEndProcessLinkText: "מעדיף שלא לנסות",
};

export const footerTexts = {
  customerServiceText: "שירות לקוחות והזמנות:",
  customerServiceValue: " 5329*",
  serviceAddressText: "כתובת: ",
  serviceAddressValue: "רחוב בת שבע 1, לוד",
  serviceEmailText: "דואר אלקטרוני: ",
  serviceEmailValue: "service@panaxia.co.il",
};

export const headerTexts = {
  progressBarstep1: "1. ",
  progressBarStep1Text: "פרטים אישיים",
  progressBarStep2: "2. ",
  progressBarStep2Text: "צירוף מסמכים",
  progressBarStep3: "3. ",
  progressBarStep3Text: "פרטים נוספים",
  progressBarStep4: "4. ",
  progressBarStep4Text: "סיום הרשמה",
};

export const selectInputTexts = {
  tooltipText:
    "המידע נאסף לצורך מתן ייעוץ רוקחי מדוייק והתאמת טיפול בהתאם-מילוי מידע זה נתון לשיקול דעת המטופל/ת בלבד",
  placeholderText: "בחר תחום...",
};

export const loaderTexts = {
  loaderText: "טוען...",
};

export const policyAndTrmesOfUseTexts = {
  policyText:
    'אנו שמחים שבחרת להשתמש במוצר מבית פנאקסיה לוגיסטיקה בע"מ, ח.פ 515752053, עבור לומינרה פארם בע"מ, ח.פ 515681948 ("אנו"), אנו משמשים כחנות ובית מרקחת מקוונים לרכישת מוצרים מבוססי קנאביס כמפורט בתנאי שימוש ורכישה אלו, בהתאם ובכפוף להוראות של משרד הבריאות. הפלטפורמה כוללת מספר ממשקים ומוצרים, לרבות אתר אינטרנט, אפליקציה סלולארית, מוקד הזמנה טלפוני, וכן היא כוללת כל ערוץ אחר בו תבחר ומתאפשר ליצור איתנו קשר, למשל פניות טלפונית והודעות דוא"ל (ביחד, "הפלטפורמה"). אנא הרגש חופשי לפנות אלינו בכל שאלה לגבי השימוש בפלטפורמה או תנאי שימוש אלו. כללי תנאי שימוש ורכישה אלו נוסחו על ידינו כדי לסייע לך להבין מה התנאים שיחולו על השימוש שלך בפלטפורמה ועל כל הזמנה או רכישה שתבצע באמצעות הפלטפורמה. השימוש בפלטפורמה מבטא הסכמה מצדך לכל תנאי השימוש המפורטים במסמך זה ובמדיניות הפרטיות שלנו (ביחד, "תנאי השימוש"). בעצם השימוש, אתה מצהיר ומאשר כי קראת את תנאי השימוש וכי אתה מודע ומסכים להם. תנאי השימוש חלים על השימוש בפלטפורמה באמצעות כל מכשיר קצה. אם אתה לא מסכים לתנאי השימוש, כולם או כל חלק מהם, או אין ברצונך למסור את המידע (כולו או חלקו) כמפורט בתנאי השימוש, אתה מתבקש שלא לעשות שימוש בפלטפורמה. אנו שומרים לעצמנו את הזכות שלא לאפשר כניסה לפלטפורמה למי שיפר את תנאי השימוש או יעשה שימוש בלתי ראוי בפלטפורמה. לצורך תנאי השימוש "המשתמש" או ״אתה״ הוא יחיד אשר בחר להיכנס לפלטפורמה ולעשות שימוש אישי בה, לרבות על ידי רכישת מוצרים. הפלטפורמה מיועדת לשימוש של יחידים בעלי הכשרות המשפטית להתחייב לתנאי שימוש אלה וליצור חוזה מחייב בהתאם לדין החל. הפלטפורמה מיועדת לשימוש לתושבי מדינת ישראל בלבד. הפלטפורמה זמינה באמצעים שונים. אנא שים לב כי ייתכנו שינויים בשימוש בין האמצעים השונים, למשל, באמצעות אתר מותאם מכשיר לאפליקציה. שים לב – הפלטפורמה איננה מיועדת לשימוש במצבי חירום. אם מדובר במצב חירום רפואי, אנא צור קשר עם הגורם הרפואי מתאים. אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש או לבצע שינוי בפלטפורמה או בשירותים שאנו נותנים בהתאם לשיקול דעתנו, ללא צורך בהודעה מוקדמת. כל שינוי מהותי בתנאי השימוש יפורסם באתר שלנו. מועד החלת השינוי יהיה מועד פרסום תנאי השימוש המעודכנים. אנו שמחים שבחרת להשתמש במוצר מבית פנאקסיה לוגיסטיקה בע"מ, ח.פ 515752053, עבור לומינרה פארם בע"מ, ח.פ 515681948 ("אנו"), אנו משמשים כחנות ובית מרקחת מקוונים לרכישת מוצרים מבוססי קנאביס כמפורט בתנאי שימוש ורכישה אלו, בהתאם ובכפוף להוראות של משרד הבריאות. הפלטפורמה כוללת מספר ממשקים ומוצרים, לרבות אתר אינטרנט, אפליקציה סלולארית, מוקד הזמנה טלפוני, וכן היא כוללת כל ערוץ אחר בו תבחר ומתאפשר ליצור איתנו קשר, למשל פניות טלפונית והודעות דוא"ל (ביחד, "הפלטפורמה"). אנא הרגש חופשי לפנות אלינו בכל שאלה לגבי השימוש בפלטפורמה או תנאי שימוש אלו. כללי תנאי שימוש ורכישה אלו נוסחו על ידינו כדי לסייע לך להבין מה התנאים שיחולו על השימוש שלך בפלטפורמה ועל כל הזמנה או רכישה שתבצע באמצעות הפלטפורמה. השימוש בפלטפורמה מבטא הסכמה מצדך לכל תנאי השימוש המפורטים במסמך זה ובמדיניות הפרטיות שלנו (ביחד, "תנאי השימוש"). בעצם השימוש, אתה מצהיר ומאשר כי קראת את תנאי השימוש וכי אתה מודע ומסכים להם. תנאי השימוש חלים על השימוש בפלטפורמה באמצעות כל מכשיר קצה. אם אתה לא מסכים לתנאי השימוש, כולם או כל חלק מהם, או אין ברצונך למסור את המידע (כולו או חלקו) כמפורט בתנאי השימוש, אתה מתבקש שלא לעשות שימוש בפלטפורמה. אנו שומרים לעצמנו את הזכות שלא לאפשר כניסה לפלטפורמה למי שיפר את תנאי השימוש או יעשה שימוש בלתי ראוי בפלטפורמה. לצורך תנאי השימוש "המשתמש" או ״אתה״ הוא יחיד אשר בחר להיכנס לפלטפורמה ולעשות שימוש אישי בה, לרבות על ידי רכישת מוצרים. הפלטפורמה מיועדת לשימוש של יחידים בעלי הכשרות המשפטית להתחייב לתנאי שימוש אלה וליצור חוזה מחייב בהתאם לדין החל. הפלטפורמה מיועדת לשימוש לתושבי מדינת ישראל בלבד. הפלטפורמה זמינה באמצעים שונים. אנא שים לב כי ייתכנו שינויים בשימוש בין האמצעים השונים, למשל, באמצעות אתר מותאם מכשיר לאפליקציה. שים לב – הפלטפורמה איננה מיועדת לשימוש במצבי חירום. אם מדובר במצב חירום רפואי, אנא צור קשר עם הגורם הרפואי מתאים. אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש או לבצע שינוי בפלטפורמה או בשירותים שאנו נותנים בהתאם לשיקול דעתנו, ללא צורך בהודעה מוקדמת. כל שינוי מהותי בתנאי השימוש יפורסם באתר שלנו. מועד החלת השינוי יהיה מועד פרסום תנאי השימוש המעודכנים.',
};
export const fileUploadInputTexts = {
  allowedFormatsText: "קבצים בפורמט: JPG, PNG, PDF",
};

export const fileUploadResultTexts = {
  deleteButtonText: "מחק קובץ",
  tryAgainText: "נסה שוב",
};

export const questionAndAnswerText = {
  questionHeaderText: "שאלה:",
  answerHeaderText: "תשובה:",
};

export const questionsAndAnswersWrapperTexts = {
  headerText: "שאלות ותשובות",
};

export const faqTexts = [
  {
    q: "האם עולה כסף להצטרף?",
    a:
      "הצטרפות למועדון פנאקסיה עד הבית אינה כרוכה בתשלום, כל לקוח קיים/חדש יכול לבחור להצטרף למועדון הלקוחות וליהנות משירות אישי, עדכונים שוטפים, תכנים ייחודיים הטבות מעת לעת.",
  },
  {
    q: "כיצד ניתן לצבור נקודות?",
    a:
      "על כל רכישה מבית המרקחת תצברו נקודות, הנקודות הן אישיות ולא ניתנות להעברה. מבצעים מותאמים אישית ישלחו אליכם באימייל מעת לעת בהתאם למצב הנקודות האישי שלכם.",
  },
  {
    q: "באילו אזורים בארץ אתם מחלקים?",
    a: "פנאקסיה עד הבית מגיעה לכל נקודה בארץ עם משלוחים עד מפתן דלתכם!",
  },
  {
    q: "עם אילו מגדלים אתם עובדים?",
    a:
      'פנאקסיה עובדת עם היצע רחב של מגדלים מישראל ומחו"ל ושואפת להגדיל תמיד את היצע המוצרים והמגדלים לטובת לקוחותיה, בין היתר ניתן למצוא באופן קבוע אצלנו במלאי את Better, Canndoc, IMC, שיח, אקסיבן ועוד..',
  },
  {
    q: "איך ניתן לבצע הזמנה?",
    a:
      "הזמנות ניתן לבצע באמצעות אתר האינטרנט שלנו <a target=_blank href=https://panaxia.store>/https://panaxia.store</a> ובאמצעות המוקד הטלפוני שלנו *5329.",
  },
  {
    q: "מהן שעות החלוקה?",
    a:
      "ההזמנות יוצאות מבית המרקחת בכל בוקר לכל חלקי הארץ*, החלקוה מתחילה החל מ8 בבוקר ועד 17:00, ובאזור מרכז הארץ ניתן גם לקבל הזמנות מהיום להיום בשעות אחר הצהריים בין 16:00-21:00.",
  },
  {
    q: "מהן שעות הפעילות של המוקד?",
    a: "מוקד ההזמנות פעיל בימים א'-ה' בין השעות 08:30-22:00.",
  },
  {
    q: "מי יכול להיות חבר מועדון?",
    a:
      "כל לקוח המטופל בקנאביס רפואי יכול להצטרף למועדון הלקוחות של פנאקסיה עד הבית ולהנות משירות אישי, תכנים ייחודיים, עדכונים והטבות!  ",
  },
  {
    q: "איך מצטרפים למועדון?",
    a: "ההצטרפות למועדון מתבצעת דרך רישום אינטרנטי פשוט הלוקח כ5 דקות!",
  },
  {
    q: "מדוע כדאי לי להיות חבר מועדון?",
    a:
      "חברי המועדון נהנים להיות הראשונים לקבל עדכונים על הטבות, מוצרים ותכנים ייחודיים, לצד הטבות לחברי המועדון בלבד! בנוסף חברי המועדון נהנים משירות אישי ומהיר לביצוע הזמנות ובירורים! ",
  },
  {
    q: "האם אוכל לקבל את הטבות המועדון גם ברכישה באתר?",
    a:
      "הטבות אשר יוצעו לחברי המועדון יהיו זמינות הן ברכישה באתר והן ברכישה באמצעות המוקד הטלפוני.",
  },
  {
    q: "כל כמה זמן מתעדכן מצב הנקודות שלי במועדון הלקוחות?",
    a: "מצב הנקודות של חבר המועדון מתעדכן לאחר כל ביצוע הזמנה.",
  },
  {
    q: "היכן נשמר המידע שלי?",
    a:
      "מידע הלקוחות נשמר תחת אבטחה ברמה גבוהה ובהתאם לתקנים המחמירים ביותר ואינו חשוף לגורמים חיצוניים כלל. ",
  },
  {
    q: "איך מבטלים את החברות במועדון הלקוחות?",
    a: "את החברות במועדון ניתן לבטל באמצעות המוקד הטלפוני בכל עת.",
  },
  {
    q: "התעדכן לי הרשיון/מרשם/פרטים אישיים, איך אפשר לעדכן?",
    a: "את הפרטים האישיים ניתן לעדכן בכל עת באמצעות המוקד הטלפוני.",
  },
  {
    q: "האם אתם מספקים שירות ייעוץ רוקחי?",
    a:
      "בית המרקחת של פנאקסיה מספק שירות ייעוץ רוקחי, ניתן לתאם שיחת ייעוץ דרך המוקד הטלפוני או אתר החברה.",
  },
  {
    q: "איפה אפשר להתעדכן במלאי הזמין שלכם?",
    a:
      "מלאי המוצרים הזמינים ללקוחותינו מופיע בכל עת ב <a target=_blank href=https://stock.panaxia.store/stock>/https://stock.panaxia.store/stock</a> והינו מעודכן לאורך כל היום, ניתן גם לעקוב אחרינו בפייסבוק ובטלגרם ולהתעדכן גם שם על המגוון הקיים במלאי.",
  },
  {
    q: "האם יש תוקף לחברות במועדון הלקוחות של פנאקסיה עד הבית?",
    a:
      "החברות במועדון הלקוחות אינה מוגבלת בזמן ולקוחות הרשומים למועדון יוכלו להמשיך ולהנות מהטבות או מבצעים ולקבל מאיתנו עדכונים ותכנים ייחודיים לאורך כל תקופת החברות שלהם.",
  },
  {
    q: "אני לא מקבל.ת שום עדכונים ומבצעים מכם לא לנייד ולא לאימייל, מדוע?",
    a:
      "נראה שהאימייל המוגדר אצלנו במערכת אינו תקין או שציינת בעבר כי אינך מעוניין לקבל דברי דואר ושיווק מאיתנו, ניתן ליצור קשר עם מוקד השירות ונשמח לעדכן את פרטייך.",
  },
];
